import React, { useState, useEffect } from 'react';
import styles from './Advertisement.module.scss';

const Advertisement = ({ 
  imageUrl, 
  text = 'Advertisement Space',
  htmlContent, 
  clickUrl = '', 
  width = '', 
  height = 'auto',
  style = {},
  onClick,
  mode = 'default', 
  trackingId, 
  trackingUrl,
  maxFileSize = 1500 * 1024, 
  allowedFormats = ['jpg', 'jpeg', 'png', 'gif']
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [fileSize, setFileSize] = useState(0);

 

  const trackClick = async () => {
    try {
      if (trackingUrl && trackingId) {
        const trackingData = {
          adId: trackingId,
          timestamp: new Date().toISOString(),
          mode: mode,
          clickUrl: clickUrl,
          userAgent: navigator.userAgent,
          referrer: document.referrer || window.location.href
        };

        await fetch(trackingUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(trackingData)
        });
      }
      
      if (window._paq) {
        window._paq.push(['trackEvent', 'Advertisement', 'Click', trackingId || 'unknown']);
      }
    } catch (error) {
      console.warn('Advertisement tracking failed:', error);
    }
  };

  const handleClick = async () => {
    await trackClick();
    
    if (onClick) {
      onClick();
    } else if (clickUrl) {
      window.open(clickUrl, '_blank', 'noopener,noreferrer');
    }
  };


  const containerStyle = {
    width,
    height: height === 'auto' ? undefined : height,
    ...style
  };

  const renderContent = () => {
    if (hasError) {
      return (
        <div className={styles['advertisement-error']}>
          Advertisement could not be loaded
        </div>
      );
    }

    // HTML5 rich media content
    if (htmlContent) {
      return (
        <div 
          className={styles['advertisement-html']}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      );
    }

    // Image content
    if (imageUrl) {
      const extension = imageUrl.split('.').pop().toLowerCase();
      
      // Handle GIF animations
      if (extension === 'gif') {
        return (
          <img 
            src={imageUrl} 
            alt="Advertisement" 
            className={styles['advertisement-image']}
            onLoad={() => setIsLoaded(true)}
            onError={() => setHasError(true)}
          />
        );
      }
      
      // Handle static images (JPG, PNG)
      return (
        <img 
          src={imageUrl} 
          alt="Advertisement" 
          className={styles['advertisement-image']}
          onLoad={() => setIsLoaded(true)}
          onError={() => setHasError(true)}
        />
      );
    }

    return (
      <div className={styles['advertisement-text']}>
        {text}
      </div>
    );
  };

  return (
    <div 
      className={`${styles['advertisement-container']} ${styles[`mode-${mode}`]}`}
      style={containerStyle}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      aria-label={`Advertisement${trackingId ? ` - ${trackingId}` : ''}`}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
      data-ad-id={trackingId}
      data-mode={mode}
    >
      {renderContent()}
          
    </div>
  );
};

export default Advertisement;
